export default {
    'bagDetail.sy': 'surplus',
    'bagDetail.sd': 'lock',
    'bagDetail.bcbzd': 'Supplementary packaging bag',
    'bagDetail.bctip': 'Please click after completing the supplement on the device',
    'bagDetail.bxybc': 'No need to supplement',
    'bagDetail.qdtip': 'After the supplement is confirmed, the remaining package will be changed to 80'
}